export default {
  hosted: 'hosted',
  directToPatient: 'direct_to_patient',
};
